import { IocContext } from 'power-di';
export * from 'power-di';
export var globalContext = IocContext.DefaultInstance;